import { useInfiniteQuery } from '@tanstack/react-query';
import {
  getBrowseProjects,
  getFollowedProjects,
  getProjects,
  getWishlist,
} from '@/src/actions/projects';
import { BrowseTabType } from '../sections/browseProjects/BrowseView';

export function useProfileProjects(uniqueLink: string) {
  return useInfiniteQuery({
    queryKey: ['profileProjects', uniqueLink],
    initialPageParam: 1,
    queryFn: async ({ pageParam = 1 }) => {
      return getProjects(null, pageParam, 100, uniqueLink);
    },
    getNextPageParam: (lastPage, pages) => {
      return lastPage.projects.length === 100 ? pages.length + 1 : undefined;
    },
  });
}

export function useLibraryProjects(
  enabled: boolean,
  activeTag: string,
  searchText: string
) {
  return useInfiniteQuery({
    queryKey: ['libraryProjects', activeTag, searchText],
    enabled,
    initialPageParam: 1,
    queryFn: async ({ pageParam = 1 }) => {
      return getProjects(null, pageParam, 16, undefined, activeTag, searchText, true );
    },
    getNextPageParam: (lastPage, pages) => {
      return lastPage.projects.length === 16 ? pages.length + 1 : undefined;
    },
  });
}

export function useFollowedProjects(
  enabled: boolean,
  activeTag: string,
  searchText: string
) {
  return useInfiniteQuery({
    queryKey: ['followedProjects', activeTag, searchText],
    enabled,
    initialPageParam: 1,
    queryFn: async ({ pageParam = 1 }) => {
      return getFollowedProjects(pageParam, 8, activeTag, searchText);
    },
    getNextPageParam: (lastPage, pages) => {
      return lastPage.projects.length === 8 ? pages.length + 1 : undefined;
    },
  });
}

export function useWishlistProjects(
  enabled: boolean,
  activeTag: string,
  searchText: string
) {
  return useInfiniteQuery({
    queryKey: ['wishlistProjects', activeTag, searchText],
    enabled,
    initialPageParam: 1,
    queryFn: async ({ pageParam = 1 }) => {
      return getWishlist(pageParam, 8, activeTag, searchText);
    },
    getNextPageParam: (lastPage, pages) => {
      return lastPage.projects.length === 8 ? pages.length + 1 : undefined;
    },
  });
}

export function useBrowseProjects(
  enabled: boolean,
  activeTab: BrowseTabType,
  activeTag: string,
  searchText: string
) {
  return useInfiniteQuery({
    queryKey: ['browseProjects', activeTab, activeTag, searchText],
    enabled,
    initialPageParam: 1,
    queryFn: async ({ pageParam = 1 }) => {
      return getBrowseProjects(pageParam, 20, activeTab, activeTag, searchText);
    },
    getNextPageParam: (lastPage, pages) => {
      return lastPage.projects.length === 20 ? pages.length + 1 : undefined;
    },
  });
}
